import React from "react";
import {
  Row,
  Col,
  Space,
  Button,
  Form,
  Input,
  Tag,
  Tooltip,
  Typography,
  Popconfirm,
  Collapse,
} from "antd";
import { useTranslation } from "react-i18next";
import AdnAvatarUpload from "../common/adnAvatarUpload/AdnAvatarUpload";
import AdnInput from "../common/adnInput/AdnInput";
import AdnEmail from "../common/adnEmail/AdnEmail";
import AdnDatePicker from "../common/adnDatePicker/AdnDatePicker";
import { AdnPhoneInput } from "../common/adnPhoneInput/AdnPhoneInput";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import AdnSwitch from "../common/adnSwitch/AdnSwitch";
import AdnTextArea from "../common/adnTextArea/AdnTextArea";
import AdnToolTip from "../common/adnToolTip/AdnToolTip";
import AdnEmailLanguagePicker from "../common/adnEmailLanguagePicker/AdnEmailLanguagePicker";
import moment from "moment";
import { X } from "react-feather";
import {
  MailOutlined,
  CheckCircleOutlined,
  HourglassOutlined,
  PlusOutlined,
  EllipsisOutlined,
  EditOutlined,
} from "@ant-design/icons";
import AdnFormOptions from "../common/adnFormOptions/AdnFormOptions";
import { NoteValidation } from "./EmployeeOfferValidations";
import {
  dateFormat,
  NameValidation,
  ContractType,
  Departement,
  AssessmentResponses,
  AssessmentResponsesDescriptionEN,
  AssessmentResponsesDescriptionPT,
} from "../common/GeneralConfigurations";
import { useNavigate } from "react-router-dom";
import {
  AdmissionCtiValidation,
  AdmissionDateValidation,
  BirthDateValidation,
  NumberValidation,
  ResignationDateValidation,
} from "./EmployeeValidations";
import AdnAutoComplete from "../common/adnAutoComplete/AdnAutoComplete";
import { AppRoutes } from "../../AppRoutes";
import { AdnValidationAdentisEmail } from "../login/LoginValidations";
import "./EmployeeConsultantDetailsForm.css";
import CaptionComponent from "../common/adnCaptionComponent/AdnCaptionComponent";
import AdnSaveButton from "../common/adnSaveButton/AdnSaveButton";
import AdnLanguagePicker from "../common/adnLanguagePicker/AdnLanguagePicker";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";
import { getSetting } from "../../api/SettingApi";
import { useState, useEffect } from "react";
import {
  getAuthenticatedUserId,
  getAuthenticatedCompanyId,
} from "../../api/ApiUtils";

// const { Text } = Typography;

function EmployeeConsultantDetailsForm({
  employeeId,
  form,
  careerLevels,
  handleContractType,
  contractTypeList,
  managersList,
  humanResList,
  selectedTemplateId,
  onTemplateChangeHandle,
  templates,
  onQuestion1Change,
  onQuestion2Change,
  onQuestion3Change,
  onQuestion4Change,
  onQuestion5Change,
  onQuestion6Change,
  isSentInquiryEmail,
  isEditing,
  isInquiryAnswered,
  onFinish,
  initialValues,
  disabledDateBirthDate,
  openEmailModal,
  workPlaceList,
  countryList,
  image,
  saveImage,
  handleChangeToCti,
  haveAdmissionCti,
  handleBlurName,
  handleBlurEmail,
  isIntegrationEmailSent,
  isProfileEmailSent,
  submitLoading,
  imgLoading,
  haveAdmissionCps,
  handleSearchReferenceBy,
  handleSelectReferenceBy,
  referenceByEmployees,
  referenceByName,
  referenceByBlur,
  tags,
  tagInputRef,
  tagEditInputRef,
  tagInputVisible,
  tagInputValue,
  editTagInputIndex,
  editTagInputValue,
  setTagEditInputIndex,
  setTagEditInputValue,
  handleCloseTag,
  showTagInput,
  handleTagInputChange,
  handleTagInputConfirm,
  handleTagEditInputChange,
  handleTagEditInputConfirm,
  isEmailEnglishLanguages,
  setisEmailEnglishLanguages,
  isEmailSending,
  isFirstMonthAssessmentEmailSent,
  isEditEnabled,
  disableEdit,
  saveEditChanges,
  handleTransition,
  techSpecializedName,
  inTransition,
  employeeFollowUpEventsCounters,
  setIsEditEnabled,
  managerEditPermission,
  hasResignationDate,
  handleResignationDateChange,
  resignationReasonOptions,
  inquiryForm,
  setFluencyLanguages,
  fluencyLanguages,
  submitInquiry,
  techSpecializedList,
  handleChangeTechSpecializedName,
  firstMonthAssessmentQuestions,
  isFirstMonthAssessmentAnswered,
  isEmailEnglishLanguage,
  isManager,
  hasCorpDepartureReason,
  departmentList,
}) {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const [settingADNProfileActive, setSettingADNProfileActive] = useState([]);
  const [settingProfileEmailActive, setSettingProfileEmailActive] = useState(
    []
  );
  const [settingIntegrationEmailActive, setSettingIntegrationEmailActive] =
    useState([]);
  const [
    settingFirstMonthAssessmentActive,
    setSettingFirstMonthAssessmentActive,
  ] = useState([]);

  const requiresAdmissionCtiDate = () => {
    return (!isEditing && haveAdmissionCti) || (isEditing && haveAdmissionCti);
  };

  const showTransit = () => {
    return (
      isEditing &&
      isEditEnabled &&
      initialValues &&
      form.getFieldValue("contractTypeId") === ContractType.Academy
    );
  };

  const translateAssessmentResponse = (value) => {
    let satisfaction;
    switch (value) {
      case AssessmentResponses.VeryDissatisfied:
        satisfaction = isEmailEnglishLanguage
          ? AssessmentResponsesDescriptionEN.VeryDissatisfied
          : AssessmentResponsesDescriptionPT.VeryDissatisfied;
        break;
      case AssessmentResponses.Dissatisfied:
        satisfaction = isEmailEnglishLanguage
          ? AssessmentResponsesDescriptionEN.Dissatisfied
          : AssessmentResponsesDescriptionPT.Dissatisfied;
        break;
      case AssessmentResponses.NotVerySatisfied:
        satisfaction = isEmailEnglishLanguage
          ? AssessmentResponsesDescriptionEN.NotVerySatisfied
          : AssessmentResponsesDescriptionPT.NotVerySatisfied;
        break;
      case AssessmentResponses.Satisfied:
        satisfaction = isEmailEnglishLanguage
          ? AssessmentResponsesDescriptionEN.Satisfied
          : AssessmentResponsesDescriptionPT.Satisfied;
        break;
      case AssessmentResponses.VerySatisfied:
        satisfaction = isEmailEnglishLanguage
          ? AssessmentResponsesDescriptionEN.VerySatisfied
          : AssessmentResponsesDescriptionPT.VerySatisfied;
        break;
    }
    return satisfaction;
  };

  const translateAssessmentResponseToColor = (satisfaction) => {
    let colorSatisfaction;
    let satisfactionInt = parseInt(satisfaction);
    switch (satisfactionInt) {
      case AssessmentResponses.VerySatisfied:
        colorSatisfaction = "#52c41a";
        break;
      case AssessmentResponses.Satisfied:
        colorSatisfaction = "#52c41a";
        break;
      case AssessmentResponses.NotVerySatisfied:
        colorSatisfaction = "#fadb14";
        break;
      case AssessmentResponses.Dissatisfied:
        colorSatisfaction = "#f5222d";
        break;
      case AssessmentResponses.VeryDissatisfied:
        colorSatisfaction = "#f5222d";
        break;
    }
    return colorSatisfaction;
  };

  const getSettingADNProfileActive = async () => {
    let settingId = "CF367BD3-9DC6-428B-A233-C44D76981741";
    getSetting(settingId).then((res) => {
      setSettingADNProfileActive(res.data);
    });
  };

  const getSettingProfileEmailActive = async () => {
    let settingId = "BCCD6F54-9EF7-4DED-8645-F2F02B67DC88";
    getSetting(settingId).then((res) => {
      setSettingProfileEmailActive(res.data);
    });
  };

  const getSettingIntegrationEmailActive = async () => {
    let settingId = "0E65B49A-38CF-4410-AA74-EB716627B102";
    getSetting(settingId).then((res) => {
      setSettingIntegrationEmailActive(res.data);
    });
  };

  const getSettingFirstMonthAssessmentActive = async () => {
    let settingId = "E28D0977-A710-430C-AC44-902570294896";
    getSetting(settingId).then((res) => {
      setSettingFirstMonthAssessmentActive(res.data);
    });
  };

  useEffect(() => {
    getSettingADNProfileActive();
    getSettingProfileEmailActive();
    getSettingIntegrationEmailActive();
    getSettingFirstMonthAssessmentActive();
  }, []);

  useEffect(() => {
    if (initialValues && form) {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, form]);

  return (
    <>
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        onFieldsChange={disableEdit}
        initialValues={initialValues}
      >
        <Row gutter={16}>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 4 }}
            xl={{ span: 4 }}
            xxl={{ span: 4 }}
          >
            <AdnAvatarUpload
              disabled={!isEditEnabled}
              imageUrl={image}
              saveImage={saveImage}
              loading={imgLoading}
            />
          </Col>
          {employeeFollowUpEventsCounters && (
            <>
              <Col
                className={"eventTextMediaQuery"}
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 12 }}
                xl={{ span: 12 }}
                xxl={{ span: 12 }}
              ></Col>
              <Col
                className="editButtonMediaQuery"
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 8 }}
                xl={{ span: 8 }}
                xxl={{ span: 8 }}
              >
                {saveEditChanges ? (
                  <Row style={{ height: "fit-content" }}>
                    <CaptionComponent
                      text={t("employeeConsultantDetails.buttons.saveChanges")}
                      status={2}
                      isBold={true}
                    />
                  </Row>
                ) : (
                  <Row justify="end" gutter={12}>
                    <Col>
                      <Button
                        onClick={() => navigate(AppRoutes.consultantList.path)}
                        disabled={managerEditPermission}
                        className="adn-outlined-button outlined-cancel"
                      >
                        Go to consultants
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        type="primary"
                        onClick={() => setIsEditEnabled(!isEditEnabled)}
                        disabled={managerEditPermission}
                        className="adn-primary-button primary-cancel"
                      >
                        {" "}
                        {isEditEnabled ? <X /> : <EditOutlined />}
                        {isEditEnabled
                          ? t("employeeConsultantDetails.buttons.cancel")
                          : t("employeeConsultantDetails.buttons.edit")}
                      </Button>
                    </Col>
                  </Row>
                )}
              </Col>
            </>
          )}
        </Row>

        <Row gutter={16}>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 12 }}
            xxl={{ span: 12 }}
          >
            <AdnInput
              name="name"
              label={t("employeeConsultantDetails.labels.name")}
              rules={NameValidation}
              placeholder={t(
                "employeeConsultantDetails.placeholders.insertName"
              )}
              maxLength={100}
              handleBlur={handleBlurName}
              //disabled={!isEditEnabled}
              disabled="false"
            />
          </Col>

          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 12 }}
            xxl={{ span: 12 }}
          >
            <AdnEmail
              handleBlur={handleBlurEmail}
              validationType={AdnValidationAdentisEmail}
              //disabled={!isEditEnabled}
              disabled="false"
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <AdnDatePicker
              name="birthDate"
              label={t("employeeConsultantDetails.labels.birthDate")}
              rules={BirthDateValidation}
              defaultPickerValue={moment("1995-01-01", dateFormat)}
              disabledDate={disabledDateBirthDate}
              format={dateFormat}
              //disabled={!isEditEnabled}
              disabled="false"
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <AdnDropdown
              name="gender"
              label={t("employeeConsultantDetails.labels.gender")}
              type="text"
              rules={[
                {
                  required: true,
                  message: t(
                    "employeeConsultantDetails.validation.genderRequired"
                  ),
                },
              ]}
              placeholder={t(
                "employeeConsultantDetails.placeholders.selectGender"
              )}
              options={[
                { id: "M", name: t("employeeConsultantDetails.options.male") },
                {
                  id: "F",
                  name: t("employeeConsultantDetails.options.female"),
                },
              ]}
              //disabled={!isEditEnabled}
              disabled="false"
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 4 }}
            xxl={{ span: 4 }}
            key={"phone"}
          >
            <>
              <AdnPhoneInput
                name="phone"
                rules={[
                  {
                    required: false,
                    message: t("consultantForm.messages.phoneRequired"),
                  },
                ]}
                //disabled={!isEditEnabled}
                disabled="false"
              />
              {initialValues && initialValues.invalidPhone && (
                <AdnToolTip
                  title={t("consultantForm.messages.invalidWhatsappNumber")}
                  color="red"
                />
              )}
            </>
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 4 }}
            xxl={{ span: 4 }}
            key={"phone2"}
          >
            <AdnPhoneInput
              name="phone2"
              label={t("employeeConsultantDetails.labels.phone")}
              //disabled={!isEditEnabled}
              disabled="false"
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 4 }}
            xxl={{ span: 4 }}
          >
            <AdnDropdown
              name="nationalityId"
              label={t("employeeConsultantDetails.labels.nationality")}
              type="text"
              placeholder={t(
                "employeeConsultantDetails.placeholders.selectNationality"
              )}
              options={countryList}
              rules={[
                {
                  required: true,
                  message: t(
                    "employeeConsultantDetails.validation.nationalityRequired"
                  ),
                },
              ]}
              //disabled={!isEditEnabled}
              disabled="false"
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <AdnDatePicker
              name="admissionDate"
              label={t("employeeConsultantDetails.labels.admissionDate")}
              rules={AdmissionDateValidation(form)}
              format={dateFormat}
              //disabled={!isEditEnabled}
              disabled="false"
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <AdnInput
              name="number"
              label={t("employeeConsultantDetails.labels.consultantNumber")}
              rules={NumberValidation(form)}
              placeholder="Insert Consultant nr."
              maxLength={30}
              //disabled={!isEditEnabled}
              disabled="false"
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <AdnDropdown
              name="managerId"
              label={t("employeeConsultantDetails.labels.manager")}
              type="text"
              rules={[
                {
                  required: true,
                  message: t(
                    "employeeConsultantDetails.validation.managerRequired"
                  ),
                },
              ]}
              placeholder={t(
                "employeeConsultantDetails.placeholders.selectManager"
              )}
              options={managersList}
              //disabled={!isEditEnabled}
              disabled="false"
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <AdnDropdown
              name="workPlaceId"
              label={t("employeeConsultantDetails.labels.location")}
              type="text"
              placeholder={t(
                "employeeConsultantDetails.placeholders.selectLocation"
              )}
              options={workPlaceList}
              rules={[
                {
                  required: true,
                  message: t(
                    "employeeConsultantDetails.validation.locationRequired"
                  ),
                },
              ]}
              //disabled={!isEditEnabled}
              disabled="false"
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <AdnDatePicker
              name="availableDate"
              label={t("employeeConsultantDetails.labels.availableDate")}
              format={dateFormat}
              disabled={!isEditEnabled}
            />
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <AdnDropdown
              name="contractTypeId"
              label={t("employeeConsultantDetails.labels.contract")}
              type="text"
              rules={[
                {
                  required: true,
                  message: t(
                    "employeeConsultantDetails.validation.contractRequired"
                  ),
                },
              ]}
              options={contractTypeList}
              placeholder={t(
                "employeeConsultantDetails.placeholders.selectContract"
              )}
              handleChange={(id) => {
                handleContractType(id);
                handleChangeToCti(id);
              }}
              //disabled={!isEditEnabled}
              disabled="false"
            />
          </Col>

          {showTransit() && (
            <Col
              className="inTransitionButton"
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 12 }}
              lg={{ span: 12 }}
              xl={{ span: 3 }}
              xxl={{ span: 3 }}
              style={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
                marginTop: 18,
              }}
            >
              {inTransition != null ? (
                inTransition === false ? (
                  <Popconfirm
                    title={`${initialValues.name} joined a client project?`}
                    onConfirm={() => {
                      handleTransition();
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        border: "0.5px solid black",
                        color: "white",
                        background:
                          inTransition === true
                            ? "rgb(255, 172, 43)"
                            : "rgb(0, 201, 114)",
                        width: "100%",
                        height: 30,
                      }}
                    >
                      Transit
                    </div>
                  </Popconfirm>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      border: "0.5px solid black",
                      color: "white",
                      background:
                        inTransition === true
                          ? "rgb(255, 172, 43)"
                          : "rgb(0, 201, 114)",
                      width: "100%",
                      height: 30,
                    }}
                  >
                    In Transition
                  </div>
                )
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    border: "0.5px solid black",
                    color: "white",
                    background: "#005888",
                    width: "100%",
                    height: 30,
                  }}
                >
                  Has Transited
                </div>
              )}
            </Col>
          )}

          {!haveAdmissionCps && (
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 12 }}
              lg={{ span: 12 }}
              xl={{ span: 6 }}
              xxl={{ span: 6 }}
            >
              <AdnDropdown
                name="carrearLevelId"
                label={t("employeeConsultantDetails.labels.careerLevel")}
                type="text"
                rules={[
                  {
                    required: true,
                    message: t(
                      "employeeConsultantDetails.validation.careerLevelRequired"
                    ),
                  },
                ]}
                placeholder={t(
                  "employeeConsultantDetails.placeholders.selectCareerLevel"
                )}
                options={careerLevels}
                disabled={!isEditEnabled}
              />
            </Col>
          )}
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <AdnInput
              name="currentCompany"
              label={t("employeeConsultantDetails.labels.currentClient")}
              placeholder={t(
                "employeeConsultantDetails.placeholders.insertCurrentClient"
              )}
              maxLength={50}
              //disabled={!isEditEnabled}
              disabled="false"
            />
          </Col>
        </Row>

        <Row gutter={16}>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <AdnDropdown
              name="departmentId"
              label={t("employeeConsultantDetails.labels.department")}
              placeholder={t(
                "employeeConsultantDetails.placeholders.chooseDepartment"
              )}
              disabled={!isEditEnabled}
              options={departmentList}
            />
            </Col>
            <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 12 }}
                xl={{ span: 6 }}
                xxl={{ span: 6 }}
            >
                <Row className="detail-title" align="middle">
                    &nbsp;
                    <p>
                        {t("employeeConsultantDetails.labels.primaveraDepartment")}
                    </p>
                </Row>
                {initialValues &&
                    initialValues.primaveraDepartmentDescription && (
                    <Row className="detail-value">
                        &nbsp;
                        <p>
                            {initialValues.primaveraDepartmentDescription}
                        </p>
                    </Row>
                )}
            </Col>
            <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 12 }}
                xl={{ span: 6 }}
                xxl={{ span: 6 }}
            >
                <AdnDropdown
                    name="workPlaceIdHumanResource"
                          label={t("employeeConsultantDetails.labels.workPlaceHumanResource")}
                    placeholder={t(
                        "employeeConsultantDetails.placeholders.selectLocation"
                    )}
                    disabled={!isEditEnabled}
                    options={workPlaceList}
                />
            </Col>
            <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 12 }}
                xl={{ span: 6 }}
                xxl={{ span: 6 }}
            >
                <AdnDropdown
                    name="userIdHumanResource"
                    label={t("employeeConsultantDetails.labels.userHumanResource")}
                    placeholder={t(
                        "employeeConsultantDetails.placeholders.chooseUser"
                    )}
                    disabled={!isEditEnabled}
                    options={humanResList}
                />
            </Col>
        </Row>

        {initialValues &&
          initialValues.techSpecializedId &&
          techSpecializedName && (
            <Col style={{ marginBottom: 20 }}>
              <Row>
                <b style={{ color: "#0a2038" }}>Role:</b> &nbsp;
                {techSpecializedName}
              </Row>
            </Col>
          )}

        <Row gutter={16}>
          {requiresAdmissionCtiDate() ? (
            <>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 12 }}
                xl={{ span: 6 }}
                xxl={{ span: 6 }}
              >
                <AdnDatePicker
                  name="admissionCtiDate"
                  label={t("employeeConsultantDetails.labels.admissionCTIDate")}
                  rules={AdmissionCtiValidation(
                    form,
                    requiresAdmissionCtiDate()
                  )}
                  format={dateFormat}
                  disabled={!isEditEnabled}
                />
              </Col>
            </>
          ) : (
            <></>
          )}
        </Row>

        <Row gutter={16}>
          {isEditing && (
            <>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 12 }}
                xl={{ span: 6 }}
                xxl={{ span: 6 }}
              >
                <AdnDatePicker
                  name="resignationDate"
                  label={t("employeeConsultantDetails.labels.resignationDate")}
                  rules={ResignationDateValidation(form)}
                  format={dateFormat}
                  onChange={handleResignationDateChange}
                  //disabled={!isEditEnabled}
                  disabled="false"
                />
              </Col>

              {hasResignationDate && hasCorpDepartureReason && (
                <>
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 9 }}
                    xxl={{ span: 9 }}
                  >
                    <AdnInput
                      name="departureReason"
                      label={t(
                        "employeeConsultantDetails.labels.resignationReason"
                      )}
                      maxLength={255}
                      disabled="false"
                    />
                  </Col>
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 9 }}
                    xxl={{ span: 9 }}
                  >
                    <AdnInput
                      name="dismissalComment"
                      label={t(
                        "employeeConsultantDetails.labels.dismissalComment"
                      )}
                      maxLength={255}
                      disabled="false"
                    />
                  </Col>
                </>
              )}
              {hasResignationDate && !hasCorpDepartureReason && (
                <>
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 9 }}
                    xxl={{ span: 9 }}
                  >
                    <AdnInput
                      name="resignationReasonId"
                      label={t(
                        "employeeConsultantDetails.labels.resignationReason"
                      )}
                      placeholder={t(
                        "employeeConsultantDetails.placeholders.selectReason"
                      )}
                      maxLength={255}
                      disabled="false"
                    />
                  </Col>
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 12 }}
                    lg={{ span: 12 }}
                    xl={{ span: 9 }}
                    xxl={{ span: 9 }}
                  >
                    <AdnInput
                      name="dismissalComment"
                      label={t(
                        "employeeConsultantDetails.labels.dismissalComment"
                      )}
                      maxLength={255}
                      disabled="false"
                    />
                  </Col>
                </>
              )}
            </>
          )}
        </Row>

        <Row gutter={16}>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 12 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <Form.Item
              label={t("employeeConsultantDetails.labels.referencedBy")}
            >
              <AdnAutoComplete
                placeholder={"Search consultant..."}
                handleSearch={handleSearchReferenceBy}
                handleSelect={handleSelectReferenceBy}
                resultList={referenceByEmployees}
                valueId={"name"}
                value={referenceByName}
                defaultValue={referenceByName}
                handleBlur={referenceByBlur}
                disabled={!isEditEnabled}
              />
            </Form.Item>
          </Col>
          <Col span={1}></Col>
          {isEditEnabled && (
            <Col>
              <Form.Item
                name="isEmailEnglishLanguage"
                label={t("employeeConsultantDetails.labels.emailLanguage")}
              >
                <AdnEmailLanguagePicker
                  isEmailEnglishLanguages={isEmailEnglishLanguages}
                  setisEmailEnglishLanguages={setisEmailEnglishLanguages}
                />
              </Form.Item>
            </Col>
          )}
          {isEditEnabled && (
            <Col style={{ marginTop: 2, marginLeft: "-15px" }}>
              <AdnToolTip
                title={t(
                  "employeeConsultantDetails.tooltips.emailLanguageSwitch"
                )}
              ></AdnToolTip>
            </Col>
          )}
        </Row>

        <Row>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 24 }}
            xl={{ span: 24 }}
            xxl={{ span: 24 }}
          >
            <AdnTextArea
              name={"note"}
              label={t("employeeConsultantDetails.labels.note")}
              maxLength={10000}
              rules={NoteValidation}
              showCount={true}
              placeholder={t(
                "employeeConsultantDetails.placeholders.anythingYouWantToAdd"
              )}
              disabled={!isEditEnabled}
            ></AdnTextArea>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col
            xs={{ span: 20 }}
            sm={{ span: 20 }}
            md={{ span: 20 }}
            lg={{ span: 20 }}
            xl={{ span: 20 }}
            xxl={{ span: 20 }}
          >
            <Form.Item label={t("consultantForm.labels.technologies")}>
              {tags.map((tag, index) => {
                if (editTagInputIndex === index) {
                  return (
                    <Input
                      ref={tagEditInputRef}
                      key={tag}
                      size="small"
                      className="tag-input"
                      value={editTagInputValue}
                      onChange={handleTagEditInputChange}
                      onBlur={handleTagEditInputConfirm}
                      onPressEnter={handleTagEditInputConfirm}
                    />
                  );
                }

                const isLongTag = tag.length > 20;
                const tagElem = (
                  <Tag
                    color="green"
                    className="edit-tag"
                    key={tag}
                    closable={isEditEnabled}
                    onClose={() => handleCloseTag(tag)}
                  >
                    <span
                      onDoubleClick={(e) => {
                        setTagEditInputIndex(index);
                        setTagEditInputValue(tag);
                        e.preventDefault();
                      }}
                    >
                      {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                    </span>
                  </Tag>
                );
                return isLongTag ? (
                  <Tooltip title={tag} key={tag}>
                    {tagElem}
                  </Tooltip>
                ) : (
                  tagElem
                );
              })}

              {tagInputVisible && (
                <Input
                  ref={tagInputRef}
                  type="text"
                  size="small"
                  className="tag-input"
                  value={tagInputValue}
                  onChange={handleTagInputChange}
                  onBlur={handleTagInputConfirm}
                  onPressEnter={handleTagInputConfirm}
                />
              )}

              {!tagInputVisible && isEditEnabled && (
                <Tag className="site-tag-plus" onClick={showTagInput}>
                  <PlusOutlined /> New Tag
                </Tag>
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          {settingADNProfileActive.value == "TRUE" &&
            !isSentInquiryEmail &&
            !isInquiryAnswered &&
            isEditing &&
            isIntegrationEmailSent === 1 &&
            isEditEnabled && (
              <>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 12 }}
                  xl={{ span: 5 }}
                  xxl={{ span: 5 }}
                >
                  <AdnDropdown
                    label={t("consultantForm.labels.adnProfileTemplate")}
                    name="templateId"
                    type="text"
                    placeholder={t(
                      "consultantForm.placeholders.selectTemplate"
                    )}
                    handleChange={onTemplateChangeHandle}
                    options={templates}
                    value={selectedTemplateId}
                  />
                </Col>
              </>
            )}
          {settingADNProfileActive.value == "TRUE" &&
          !isSentInquiryEmail &&
          !isInquiryAnswered &&
          isEditing &&
          isIntegrationEmailSent === 1 ? (
            <>
              {isEmailSending ? (
                <>
                  <EllipsisOutlined
                    style={{
                      fontSize: "20px",
                      color: "#08c",
                      marginTop: "35px",
                    }}
                  />
                </>
              ) : (
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 12 }}
                  xl={{ span: 5 }}
                  xxl={{ span: 5 }}
                >
                  {isEditEnabled && !isManager && selectedTemplateId > 0 && (
                    <Button
                      icon={<MailOutlined />}
                      style={{ marginTop: 22 }}
                      className="adn-primary-button"
                      type="primary"
                      onClick={() => openEmailModal("ADNProfile")}
                    >
                      Send Email
                    </Button>
                  )}
                </Col>
              )}
            </>
          ) : (
            <></>
          )}
        </Row>

        {(settingADNProfileActive.value == "TRUE" &&
          !isSentInquiryEmail &&
          !isInquiryAnswered &&
          selectedTemplateId != null &&
          isEditing &&
          isIntegrationEmailSent === 1) ||
        (settingADNProfileActive.value == "TRUE" &&
          !isSentInquiryEmail &&
          !isInquiryAnswered &&
          isEditing &&
          isIntegrationEmailSent === 1) ? (
          <>
            {isEditEnabled && (
              <div className="fixedTemplateBlock">
                <Row align="top">
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 16 }}
                    xl={{ span: 9 }}
                    xxl={{ span: 9 }}
                  >
                    <AdnInput
                      name="question1"
                      label="Question 1"
                      onChange={onQuestion1Change}
                    />
                  </Col>
                  <Col span={1} />
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 16 }}
                    xl={{ span: 9 }}
                    xxl={{ span: 9 }}
                  >
                    <AdnInput
                      name="question2"
                      label="Question 2"
                      onChange={onQuestion2Change}
                    />
                  </Col>
                  <Col span={1} />
                </Row>

                <Row align="top">
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 16 }}
                    xl={{ span: 9 }}
                    xxl={{ span: 9 }}
                  >
                    <AdnInput
                      name="question3"
                      label="Question 3"
                      onChange={onQuestion3Change}
                    />
                  </Col>
                  <Col span={1} />
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 16 }}
                    xl={{ span: 9 }}
                    xxl={{ span: 9 }}
                  >
                    <AdnInput
                      name="question4"
                      label="Question 4"
                      onChange={onQuestion4Change}
                    />
                  </Col>
                </Row>

                <Row align="top">
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 16 }}
                    xl={{ span: 9 }}
                    xxl={{ span: 9 }}
                  >
                    {
                      <strong>
                        <AdnInput
                          name="question5"
                          label="Question 5"
                          onChange={onQuestion5Change}
                        />
                      </strong>
                    }
                  </Col>
                  <Col span={1} />
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 16 }}
                    xl={{ span: 9 }}
                    xxl={{ span: 9 }}
                  >
                    {
                      <strong>
                        <AdnInput
                          name="question6"
                          label="Question 6"
                          onChange={onQuestion6Change}
                        />
                      </strong>
                    }
                  </Col>
                </Row>
              </div>
            )}
          </>
        ) : (
          <></>
        )}

        <br />
        <Row gutter={16}>
          {settingADNProfileActive.value == "TRUE" &&
            isEditing &&
            isSentInquiryEmail &&
            !isInquiryAnswered && (
              <>
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 12 }}
                  xl={{ span: 12 }}
                  xxl={{ span: 5 }}
                >
                  <Form.Item
                    label={t("consultantForm.labels.adnProfileTemplate")}
                  >
                    <HourglassOutlined
                      style={{ fontSize: "20px", color: "#D3D3D3" }}
                    />
                  </Form.Item>
                </Col>
                <br />
              </>
            )}
          {isEditing && (
            <>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 12 }}
                xl={{ span: 5 }}
                xxl={{ span: 5 }}
              >
                <Form.Item label={t("consultantForm.labels.integrationEmail")}>
                  {isIntegrationEmailSent === 1 ? (
                    <>
                      <CheckCircleOutlined className="action-svg" />
                    </>
                  ) : isEmailSending ? (
                    <>
                      <EllipsisOutlined className="action-svg" />
                    </>
                  ) : (
                    <>
                      {isEditEnabled &&
                        !isManager &&
                        settingIntegrationEmailActive.value == "FALSE" && (
                          <Button
                            icon={<MailOutlined />}
                            type="primary"
                            className="adn-primary-button-disabled"
                            disabled
                          >
                            {" "}
                            Send
                          </Button>
                        )}
                      {isEditEnabled &&
                        !isManager &&
                        settingIntegrationEmailActive.value == "TRUE" && (
                          <Button
                            icon={<MailOutlined />}
                            type="primary"
                            className="adn-primary-button"
                            onClick={() => openEmailModal("Integration")}
                          >
                            {" "}
                            Send
                          </Button>
                        )}
                    </>
                  )}
                </Form.Item>
              </Col>

              {settingProfileEmailActive.value == "TRUE" &&
                isInquiryAnswered && (
                  <>
                    <Col
                      xs={{ span: 24 }}
                      sm={{ span: 24 }}
                      md={{ span: 24 }}
                      lg={{ span: 12 }}
                      xl={{ span: 5 }}
                      xxl={{ span: 5 }}
                    >
                      <Form.Item label={"Profile Email"}>
                        {isProfileEmailSent ? (
                          <>
                            <CheckCircleOutlined className="action-svg" />
                          </>
                        ) : isEmailSending ? (
                          <>
                            <EllipsisOutlined className="action-svg" />
                          </>
                        ) : (
                          <>
                            {isEditEnabled && !isManager && (
                              <Button
                                icon={<MailOutlined />}
                                type="primary"
                                className="adn-primary-button"
                                onClick={() => openEmailModal("Profile")}
                              >
                                {" "}
                                Send
                              </Button>
                            )}
                          </>
                        )}
                      </Form.Item>
                    </Col>
                  </>
                )}
              {
                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 24 }}
                  lg={{ span: 12 }}
                  xl={{ span: 5 }}
                  xxl={{ span: 5 }}
                >
                  <Form.Item
                    label={t("consultantForm.labels.firstMonthAssessment")}
                  >
                    {isFirstMonthAssessmentEmailSent ? (
                      <>
                        <CheckCircleOutlined className="action-svg" />
                      </>
                    ) : isEmailSending ? (
                      <>
                        <EllipsisOutlined className="action-svg" />
                      </>
                    ) : (
                      <>
                        {isEditEnabled &&
                          !isManager &&
                          settingFirstMonthAssessmentActive.value ==
                            "FALSE" && (
                            <Button
                              icon={<MailOutlined />}
                              type="primary"
                              className="adn-primary-button-disabled"
                              disabled
                            >
                              {" "}
                              Send
                            </Button>
                          )}
                        {isEditEnabled &&
                          !isManager &&
                          settingFirstMonthAssessmentActive.value == "TRUE" && (
                            <Button
                              icon={<MailOutlined />}
                              type="primary"
                              className="adn-primary-button"
                              onClick={() =>
                                openEmailModal("FirstMonthAssessment")
                              }
                            >
                              {" "}
                              Send
                            </Button>
                          )}
                      </>
                    )}
                  </Form.Item>
                </Col>
              }

              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 12 }}
                xl={{ span: 12 }}
                xxl={{ span: 5 }}
              >
                {isEditEnabled && !isManager && (
                  <AdnSwitch
                    name="hasCorpDone"
                    label="Corp Done"
                    checkedText="Done"
                    disabled={initialValues ? initialValues.hasCorpDone : false}
                    defaultChecked={
                      initialValues ? initialValues.hasCorpDone : false
                    }
                  />
                )}
              </Col>
            </>
          )}
        </Row>

        <br />
        {isEditEnabled && (
          <AdnFormOptions
            handleCancel={() => {
              navigate(AppRoutes.consultantList.path);
            }}
            loading={submitLoading}
            canceltext={t("employeeConsultantDetails.buttons.goToConsultants")}
          />
        )}
      </Form>

      {isInquiryAnswered && (
        <>
          <Collapse ghost={true}>
            <CollapsePanel
              header={
                <Row align="middle">
                  <h4 style={{ fontSize: "140%" }}>
                    ADN Profile{" "}
                    <CheckCircleOutlined
                      style={{ fontSize: "20px", color: "#08c" }}
                    />
                  </h4>
                </Row>
              }
            >
              <Form
                layout="vertical"
                form={inquiryForm}
                onFinish={submitInquiry}
                initialValues={initialValues ? initialValues : []}
              >
                <br />

                <Row>
                  <Col span={2} />
                  <Col span={7}>
                    <AdnInput
                      name="placeOfBirth"
                      label={"Place Of Birth"}
                      placeholder="(Country, City)"
                      maxLength={50}
                      rules={[{ required: true, message: "Field is required" }]}
                      disabled={!isEditEnabled}
                    />
                  </Col>
                  <Col span={1} />
                  <Col span={7}>
                    <AdnDropdown
                      name={"techSpecializedId"}
                      label={"Role"}
                      options={techSpecializedList}
                      handleChange={handleChangeTechSpecializedName}
                      placeholder="Please select a role"
                      rules={[{ required: true, message: "Field is required" }]}
                      disabled={!isEditEnabled}
                    />
                  </Col>
                  <Col span={1} />
                  <Col>
                    <Form.Item name={"languages"} label="Languages">
                      <AdnLanguagePicker
                        fluencyLanguages={fluencyLanguages}
                        setFluencyLanguages={setFluencyLanguages}
                        disabled={!isEditEnabled}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row style={{ paddingBottom: "5px" }}>
                  <Col span={2} />
                  <Col span={19}>
                    <AdnTextArea
                      name={"professionalResume"}
                      label="Professional Resume"
                      showCount={true}
                      maxLength={300}
                      rules={[{ required: true, message: "Field is required" }]}
                      disabled={!isEditEnabled}
                    />
                  </Col>
                </Row>
                <div className="fixedTemplateBlock">
                  <Row align="top">
                    <Col span={2} />
                    <Col span={9}>
                      <AdnInput
                        name="response1"
                        label={initialValues ? initialValues.question1 : ""}
                        placeholder={"Resposta 1"}
                        maxLength={100}
                        rules={[
                          {
                            required: true,
                            message: "Field is required",
                          },
                        ]}
                        disabled={!isEditEnabled}
                      />
                    </Col>
                    <Col span={1} />
                    <Col span={9}>
                      <AdnInput
                        name="response2"
                        label={initialValues ? initialValues.question2 : ""}
                        placeholder={"Resposta 2"}
                        maxLength={100}
                        rules={[
                          {
                            required: true,
                            message: "Field is required",
                          },
                        ]}
                        disabled={!isEditEnabled}
                      />
                    </Col>
                    <Col span={1} />
                  </Row>
                  <Row align="top">
                    <Col span={2} />
                    <Col span={9}>
                      <AdnInput
                        name="response3"
                        label={initialValues ? initialValues.question3 : ""}
                        placeholder={"Resposta 3"}
                        maxLength={100}
                        rules={[
                          {
                            required: true,
                            message: "Field is required",
                          },
                        ]}
                        disabled={!isEditEnabled}
                      />
                    </Col>

                    <Col span={1} />

                    <Col span={9}>
                      <AdnInput
                        name="response4"
                        label={initialValues ? initialValues.question4 : ""}
                        placeholder={"Resposta 4"}
                        maxLength={100}
                        rules={[
                          {
                            required: true,
                            message: "Field is required",
                          },
                        ]}
                        disabled={!isEditEnabled}
                      />
                    </Col>
                  </Row>
                  <Row align="top">
                    <Col span={2} />
                    <Col span={9}>
                      <AdnInput
                        name="response5"
                        label={
                          <strong>
                            {initialValues ? initialValues.question5 : ""}
                          </strong>
                        }
                        placeholder={"Resposta 5"}
                        maxLength={100}
                        rules={[
                          {
                            required: true,
                            message: "Field is required",
                          },
                        ]}
                        disabled={!isEditEnabled}
                      />
                    </Col>
                    <Col span={1} />
                    <Col span={9}>
                      <AdnInput
                        name="response6"
                        label={
                          <strong>
                            {initialValues ? initialValues.question6 : ""}
                          </strong>
                        }
                        placeholder={"Resposta 6"}
                        maxLength={100}
                        rules={[
                          {
                            required: true,
                            message: "Field is required",
                          },
                        ]}
                        disabled={!isEditEnabled}
                      />
                    </Col>
                  </Row>
                  {isEditEnabled && (
                    <Row justify="end">
                      <Space>
                        <Col>
                          <AdnSaveButton />
                        </Col>
                      </Space>
                    </Row>
                  )}
                </div>
              </Form>
            </CollapsePanel>
          </Collapse>
        </>
      )}

      {isFirstMonthAssessmentAnswered && firstMonthAssessmentQuestions[0] && (
        <>
          <Collapse ghost={true}>
            <CollapsePanel
              header={
                <Row align="middle">
                  <h4 style={{ fontSize: "140%" }}>
                    {t("consultantForm.labels.firstMonthAssessment")}
                    <CheckCircleOutlined
                      style={{ fontSize: "20px", color: "#08c" }}
                    />
                  </h4>
                </Row>
              }
            >
              <Form
                layout="vertical"
                initialValues={
                  firstMonthAssessmentQuestions[3]
                    ? {
                        ["question0"]:
                          firstMonthAssessmentQuestions[2]
                            .firstMonthAssessmentResponse,
                        ["question1"]:
                          firstMonthAssessmentQuestions[3]
                            .firstMonthAssessmentResponse,
                        ["question2"]:
                          firstMonthAssessmentQuestions[4]
                            .firstMonthAssessmentResponse,
                        ["question3"]:
                          firstMonthAssessmentQuestions[5]
                            .firstMonthAssessmentResponse,
                        ["question4"]:
                          firstMonthAssessmentQuestions[6]
                            .firstMonthAssessmentResponse,
                        ["question5"]:
                          firstMonthAssessmentQuestions[7]
                            .firstMonthAssessmentResponse,
                        ["question6"]:
                          firstMonthAssessmentQuestions[8]
                            .firstMonthAssessmentResponse,
                        ["question7"]:
                          firstMonthAssessmentQuestions[9]
                            .firstMonthAssessmentResponse,
                        ["question8"]:
                          firstMonthAssessmentQuestions[10]
                            .firstMonthAssessmentResponse,
                        ["question9"]:
                          firstMonthAssessmentQuestions[11]
                            .firstMonthAssessmentResponse,
                      }
                    : []
                }
              >
                <Row>
                  <Col span={2} />
                </Row>
                <Row style={{ fontWeight: "bold", fontSize: "0.9rem" }}>
                  <Col span={2} />
                  {"- ".concat(
                    firstMonthAssessmentQuestions[0]
                      ?.firstMonthAssessmentQuestionName
                  )}
                </Row>
                <br></br>
                <Row>
                  <Col span={3} />
                  <Col span={20}>
                    <p>
                      {"".concat(
                        firstMonthAssessmentQuestions[3]?.firstMonthAssessmentQuestionName.concat(
                          ": "
                        )
                      )}
                      <b
                        style={{
                          fontSize: "1rem",
                          color: translateAssessmentResponseToColor(
                            firstMonthAssessmentQuestions[3]
                              .firstMonthAssessmentResponse
                          ),
                        }}
                      >
                        {translateAssessmentResponse(
                          parseInt(
                            firstMonthAssessmentQuestions[3]
                              .firstMonthAssessmentResponse
                          )
                        )}
                      </b>
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col span={3} />
                  <Col span={20}>
                    <p>
                      {"".concat(
                        firstMonthAssessmentQuestions[4]?.firstMonthAssessmentQuestionName.concat(
                          ": "
                        )
                      )}
                      <b
                        style={{
                          fontSize: "1rem",
                          color: translateAssessmentResponseToColor(
                            firstMonthAssessmentQuestions[4]
                              .firstMonthAssessmentResponse
                          ),
                        }}
                      >
                        {translateAssessmentResponse(
                          parseInt(
                            firstMonthAssessmentQuestions[4]
                              .firstMonthAssessmentResponse
                          )
                        )}
                      </b>
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col span={3} />
                  <Col span={20}>
                    <p>
                      {"".concat(
                        firstMonthAssessmentQuestions[5]?.firstMonthAssessmentQuestionName.concat(
                          ": "
                        )
                      )}
                      <b
                        style={{
                          fontSize: "1rem",
                          color: translateAssessmentResponseToColor(
                            firstMonthAssessmentQuestions[5]
                              .firstMonthAssessmentResponse
                          ),
                        }}
                      >
                        {translateAssessmentResponse(
                          parseInt(
                            firstMonthAssessmentQuestions[5]
                              .firstMonthAssessmentResponse
                          )
                        )}
                      </b>
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col span={3} />
                  <Col span={20}>
                    <p>
                      {"".concat(
                        firstMonthAssessmentQuestions[6]?.firstMonthAssessmentQuestionName.concat(
                          ": "
                        )
                      )}
                      <b
                        style={{
                          fontSize: "1rem",
                          color: translateAssessmentResponseToColor(
                            firstMonthAssessmentQuestions[6]
                              .firstMonthAssessmentResponse
                          ),
                        }}
                      >
                        {translateAssessmentResponse(
                          parseInt(
                            firstMonthAssessmentQuestions[6]
                              .firstMonthAssessmentResponse
                          )
                        )}
                      </b>
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col span={3} />
                  <Col span={20}>
                    <p>
                      {"".concat(
                        firstMonthAssessmentQuestions[7]?.firstMonthAssessmentQuestionName.concat(
                          ": "
                        )
                      )}
                      <b
                        style={{
                          fontSize: "1rem",
                          color: translateAssessmentResponseToColor(
                            firstMonthAssessmentQuestions[7]
                              .firstMonthAssessmentResponse
                          ),
                        }}
                      >
                        {translateAssessmentResponse(
                          parseInt(
                            firstMonthAssessmentQuestions[7]
                              .firstMonthAssessmentResponse
                          )
                        )}
                      </b>
                    </p>
                  </Col>
                </Row>
                <br></br>
                <Row>
                  <Col span={2} />
                </Row>
                <Row style={{ fontWeight: "bold", fontSize: "0.9rem" }}>
                  <Col span={2} />
                  {"- ".concat(
                    firstMonthAssessmentQuestions[1]
                      ?.firstMonthAssessmentQuestionName
                  )}
                </Row>
                <br></br>
                <Row>
                  <Col span={3} />
                  <Col span={20}>
                    <p>
                      {"".concat(
                        firstMonthAssessmentQuestions[8]?.firstMonthAssessmentQuestionName.concat(
                          ": "
                        )
                      )}
                      <b
                        style={{
                          fontSize: "1rem",
                          color: translateAssessmentResponseToColor(
                            firstMonthAssessmentQuestions[8]
                              .firstMonthAssessmentResponse
                          ),
                        }}
                      >
                        {translateAssessmentResponse(
                          parseInt(
                            firstMonthAssessmentQuestions[8]
                              .firstMonthAssessmentResponse
                          )
                        )}
                      </b>
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col span={3} />
                  <Col span={20}>
                    <p>
                      {"".concat(
                        firstMonthAssessmentQuestions[9]?.firstMonthAssessmentQuestionName.concat(
                          ": "
                        )
                      )}
                      <b
                        style={{
                          fontSize: "1rem",
                          color: translateAssessmentResponseToColor(
                            firstMonthAssessmentQuestions[9]
                              .firstMonthAssessmentResponse
                          ),
                        }}
                      >
                        {translateAssessmentResponse(
                          parseInt(
                            firstMonthAssessmentQuestions[9]
                              .firstMonthAssessmentResponse
                          )
                        )}
                      </b>
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col span={3} />
                  <Col span={20}>
                    <p>
                      {"".concat(
                        firstMonthAssessmentQuestions[10]?.firstMonthAssessmentQuestionName.concat(
                          ": "
                        )
                      )}
                      <b
                        style={{
                          fontSize: "1rem",
                          color: translateAssessmentResponseToColor(
                            firstMonthAssessmentQuestions[10]
                              .firstMonthAssessmentResponse
                          ),
                        }}
                      >
                        {translateAssessmentResponse(
                          parseInt(
                            firstMonthAssessmentQuestions[10]
                              .firstMonthAssessmentResponse
                          )
                        )}
                      </b>
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col span={3} />
                  <Col span={20}>
                    <p>
                      {"".concat(
                        firstMonthAssessmentQuestions[11]?.firstMonthAssessmentQuestionName.concat(
                          ": "
                        )
                      )}
                      <b
                        style={{
                          fontSize: "1rem",
                          color: translateAssessmentResponseToColor(
                            firstMonthAssessmentQuestions[11]
                              .firstMonthAssessmentResponse
                          ),
                        }}
                      >
                        {translateAssessmentResponse(
                          parseInt(
                            firstMonthAssessmentQuestions[11]
                              .firstMonthAssessmentResponse
                          )
                        )}
                      </b>
                    </p>
                  </Col>
                </Row>
                <br></br>
                <Row>
                  <Col span={2} />
                  <Col span={19}>
                    <p style={{ fontSize: "0.9rem", fontWeight: "bold" }}>
                      {firstMonthAssessmentQuestions[2]
                        .firstMonthAssessmentResponse &&
                        "- ".concat(
                          firstMonthAssessmentQuestions[2]
                            ?.firstMonthAssessmentQuestionName
                        )}
                    </p>
                    <p>
                      {firstMonthAssessmentQuestions[2]
                        .firstMonthAssessmentResponse &&
                        "  ".concat(
                          firstMonthAssessmentQuestions[2]
                            .firstMonthAssessmentResponse
                        )}
                    </p>
                    <p>
                      {!firstMonthAssessmentQuestions[2]
                        .firstMonthAssessmentResponse && (
                        <p
                          style={{
                            fontSize: "0.9rem",
                            fontWeight: "bold",
                          }}
                        >
                          {isEmailEnglishLanguage
                            ? "- No suggestions have been reported"
                            : "- Não foram reportadas sugestões"}
                        </p>
                      )}
                    </p>
                  </Col>
                </Row>
              </Form>
            </CollapsePanel>
          </Collapse>
        </>
      )}
    </>
  );
}

export default EmployeeConsultantDetailsForm;
